import { QuestionnaryModel } from './questionnary.model';

import { ObjectifModel } from './objectif.model';


export class AnswerModel
{
	id: number = undefined;
	evolution: number;

	gravityArray: Array<boolean>;
	gravityScore: number;	//à calculer

	//revelent is for active (if > 0) and weighting
	revelent: number = 1;
	freetext: string = '';
	freephoto: Array<any> = [''];
	indicatorDefaults = {
		weighting: 1,
		multichoicegravity: 0,
		gravities: [],
	}

	get active()
	{
		return this.revelent > 0;
	}
	set active(a:boolean)
	{
		if(a) this.revelent = this.indicatorDefaults.weighting;
		else this.revelent = 0;
	}

	//get gravity data to record in database
	get gravity() {
		if(this.indicatorDefaults.multichoicegravity==-10)
			return null;

		if(this.indicatorDefaults.multichoicegravity!=0) return this.gravityArray.toString();

		return this.gravityScore.toString();
	}

	set gravity(g) {
		if(!isNaN(+g)) {	//is numeric
			this.gravityScore = +g;
		} else { 			//is stringified array
			this.gravityArray = [];
			g.split(',').forEach(el =>{ this.gravityArray.push( el=='true' ) });
		}
	}


	get score():number {

		if(this.indicatorDefaults.multichoicegravity==-10) return null;
		else if(this.indicatorDefaults.multichoicegravity==1) {
			this.gravityScore = 0;
			for (let g=0; g<5; g++) {
				if(this.gravityArray[g]) this.gravityScore+=this.indicatorDefaults.gravities[g].weight;
			}

		} else if(this.indicatorDefaults.multichoicegravity==-1) {
			this.gravityScore = 5;
			for (let g=0; g<5; g++) {
				if(this.gravityArray[g]) this.gravityScore-=this.indicatorDefaults.gravities[g].weight;
			}
		}


		if(this.gravityScore>5) this.gravityScore = 5;
		if (this.revelent!=0 && this.gravityScore>0 && this.gravityScore<1) this.gravityScore = 1;

		this.gravityScore = Math.round(this.gravityScore * 100) / 100;
		return Math.round(this.evolution * this.gravityScore * 100) / 100;

	}


	get finalScore():number {
		if(!this.revelent) return 0;
		else return this.score;
	}



	slice:any = {
			name: '',
			color: 'white'
		};

	get completed()
	{
		if(!this.active) return true;

		if(this.indicatorDefaults.multichoicegravity==-10) {
			return (this.freetext!=null && this.freetext!='');
		} else {
			return (this.score>0);
		}
	}



	constructor(values) {
		this.gravityArray = [false,false,false,false,false];
		this.gravityScore = 0;
		this.evolution = null;
		this.exchange(values);
	}



	exchange(values: any) {

		if(values.id) this.id = values.id;
		if(values.evolution) 	this.evolution 	= values.evolution;
		if(values.gravity) 		this.gravity 	= values.gravity;


		if(values.freetext) 	this.freetext 	= values.freetext;
		if(values.freephoto) 	this.freephoto 	= this.managePhotoFormat(values.freephoto);

		if(values.revelent) this.revelent 	= +values.revelent;
		else				this.revelent = this.indicatorDefaults.weighting;

	}

	managePhotoFormat(photoText:string)
	{
		//test old format
		if(photoText.slice(0,10) == 'data:image') {
			return [photoText];
		} else {
			 return JSON.parse(photoText);
		}
	}

	addPhoto(photo, index)
	{
		if(photo=='') this.freephoto.splice(index, 1); //delete
		else this.freephoto[index] = photo; //add

		let last = this.freephoto[this.freephoto.length - 1];
		if(last != '') this.freephoto.push('');
	}

	export()
	{
		return {
	        id: this.id,
	        evolution: this.evolution,
	        gravity: this.gravity,
	        score: this.finalScore,
	        revelent: this.active ? this.revelent : 0,
			freetext: this.freetext,
			freephoto: JSON.stringify(this.freephoto)
	    }
	}

	public resetGravity()
	{
		this.gravityArray = [false,false,false,false,false];
		this.gravityScore = 0;
	}
	public resetEvolution()
	{
		this.evolution = null;
	}

	objectif:ObjectifModel = undefined;
}
